export enum ALabelSize {
  S = 'S',
  XS = 'XS',
}

export interface ALabelProps extends React.HTMLAttributes<HTMLSpanElement> {
  /**
   * The size variant of the label
   */
  size?: ALabelSize;
  /**
   * The text to render
   */
  text: string;
}
